import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import styled from 'styled-components';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import { useIsUngatedForBreeze } from '../../../hooks/useIsUngatedForBreeze';
import { getStyledAIIconButton } from './styledButtons/StyledAIBaseIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * We can only pass a number or string to UIIcon
 * We cannot use an em for relative sizing
 * To work about this we can use a transform to scale the icon
 */
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "CopilotBaseIconButton__StyledIcon",
  componentId: "sc-1kopm0o-0"
})(["transform:scale(1.2);"]);
export function CopilotBaseIconButton(_ref) {
  let {
      use = 'tertiary-light' // default to tertiary-light
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const useOverride = use === BREEZE_SPECIAL ? undefined : use;
  const isUngatedForBreeze = useIsUngatedForBreeze();
  if (!isUngatedForBreeze) {
    return /*#__PURE__*/_jsx(UIIconButton, Object.assign({}, uiButtonProps, {
      use: useOverride,
      children: /*#__PURE__*/_jsx(StyledIcon, {
        name: "chatspot"
      })
    }));
  }
  const AIButtonComponent = getStyledAIIconButton(use);
  return /*#__PURE__*/_jsx(AIButtonComponent, Object.assign({}, uiButtonProps, {
    use: useOverride,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "artificialIntelligence"
    })
  }));
}